module.exports = __webpack_public_path__ + "static/media/nv-baies.2b3f0d7d.jpg";